module.exports = __webpack_public_path__ + "6ff42b741bf5fe6ca2a5b11fb9331488.png";